module.exports = __webpack_public_path__ + "img/calendar.589bd5fe.svg";